<template>
  <div>
    <Header />
    <Search />
    <div class="buy">
      <div class="succeed">
        <img src="../../assets/order/succeed.png" alt="" />
      </div>
      <div class="goumai">{{ $t('common.Successful_purchase') }}</div>
      <div class="chuli">{{ $t('common.shortmessage-001') }}</div>
      <div class="xiang">
        <div class="xiang_L" @click="dingdan">{{ $t('common.View_order_details') }}</div>
        <div class="xiang_R" @click="home">{{ $t('common.Look_around') }}</div>
      </div>

      <div class="tixing">
        <img src="../../assets/order/tixing.png" alt="" />
        <div class="wen">
          {{ $t('common.longmessage-001') }}
        </div>
      </div>
    </div>
    <!-- <Baoyou /> -->
    <div class="kongbai"></div>
    <Foot />
  </div>
</template>
<script>
import Header from '@/components/header.vue'
import Foot from '@/components/foot.vue'
import Search from '@/components/order/buy_succeed/search.vue'
import Baoyou from '@/components/order/baoyou.vue'
export default {
  components: {
    Header,
    Foot,
    Search,
    Baoyou
  },
  methods: {
    home() {
      this.$router.push('/')
    },
    dingdan() {
      this.$router.push({
        name: 'Dingdan'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.buy {
  width: 675px;
  border: 2px solid #f1f1f1;
  margin: 57px auto;
  padding-left: 85px;
  padding-bottom: 30px;
  .succeed {
    width: 43px;
    height: 43px;
    margin-top: 29px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .goumai {
    font-size: 24px;
    color: #fd902b;
    margin-top: 17px;
  }
  .chuli {
    font-size: 24px;
    color: #fd902b;
    margin-top: 10px;
  }

  .dingdan {
    font-size: 14px;
    color: #777;
    margin-top: 10px;
    .spen {
      color: #282828;
    }
  }
  .ding {
    margin-top: 23px;
  }
  .xiang {
    margin-top: 22px;
    color: #2558f2;
    display: flex;
    font-size: 14px;
    .xiang_L {
      cursor: pointer;
    }
    .xiang_R {
      margin-left: 30px;
      cursor: pointer;
    }
  }
  .tixing {
    width: 620px;
    height: 56px;
    display: flex;
    align-items: center;
    border-top: 1px solid #e3e3e3;
    margin-top: 35px;
    padding-top: 10px;
    line-height: 30px;
    img {
      width: 16px;
      height: 16px;
    }
    .wen {
      font-size: 14px;
      color: #888;
      margin-left: 10px;
    }
  }
}
</style>
